define('app-Search/core/service',['./serviceUrls', 'underscore'], function (serviceUrls, _) {
    // This is a service layer that allows us to keep track of all the 
    // requests that the search control, as a whole, makes.
    // Multiple systems can either use separate instances or, by using the same storage key,
    // share a search as it is built.
    return function (storageKey) {
        var self = this;
        self.rate = 150;
        self.requestLimit = 6;

        if (!window.SearchService) window.SearchService = {};

        if (!window.SearchService[storageKey]) window.SearchService[storageKey] = {
            observers: [],
            search: [],
            notifyOnActivity: [],
            pendingRequests: 0,
            requestCounts: []
        };

        // Cache our requests so we don't need to repeat them.
        if (!window.SearchService.cache) window.SearchService.cache = [];
        if (!window.SearchService.requests) window.SearchService.requests = [];

        setInterval(function () {
            var spaces = self.requestLimit - window.SearchService[storageKey].pendingRequests;
            if (spaces < 1) return;

            var pendingRequests = window.SearchService.requests.splice(0, spaces);
            _.each(pendingRequests, function (indRequest) {
                indRequest();
            });
        }, self.rate);

        // Notify each subscriber that the search terms have changed.
        // (We throttle this so that multiple changes can be made before 
        // we ping out updates);
        var notify = _.debounce(function (except, notifiedList) {
            if (!notifiedList)
                notifiedList = [];
            notifiedList.push(except);
            _.each(window.SearchService[storageKey].observers, function (o) {
                if (!except || o.key !== except)
                    o.callback(notifiedList);
            });
        }, self.rate);

        // Notify subscribers that all network activity is now finished.
        var notifyActivity = function (msg) {
            _.each(window.SearchService[storageKey].notifyOnActivity, function (w) {
                if (w) {
                    w(msg);
                }
            });
        };

        self.getRequestMonitor = function (url, query) {
            return _.find(window.SearchService[storageKey].requestCounts, function (r) {
                return r.url === url;
            });
        };

        // Make a request to a service line with a query for new data.
        self.request = function (url, query, callback, disableNotifications) {
            if (!callback) throw ('Request made with no success callback.');
            if (window.waitForUrlChecker) return;

            if (disableNotifications !== false) notifyActivity('loading');

            var cached = _.find(window.SearchService.cache, function (c) {
                return c.url === url && JSON.stringify(c.query) === JSON.stringify(query);
            });

            // Clear out old cached data from more than 60 seconds ago.
            window.SearchService.cache = _.reject(window.SearchService.cache, function (c) {
                var now = new Date().getTime();
                return c.TimeStamp < now - 60000;
            });

            if (cached) {
                callback(cached.response);
                if (window.SearchService[storageKey].pendingRequests === 0) {
                    notifyActivity('load complete');
                }
                return;
            }

            // Multiple requests might be fired off with the same credentials, we only
            // want to honour the *last* one.  We store each request URL and pararms
            // along with an incrementing number.
            // When the request returns, we compare its number to the last request number
            // for those same parameters and URL.  If they are different then we drop
            // the request since a newer version has since returned.
            var requestMonitor = self.getRequestMonitor(url, query);
            if (!requestMonitor) {
                requestMonitor = {
                    url: url,
                    current: 0
                };

                window.SearchService[storageKey].requestCounts.push(requestMonitor);
            }

            requestMonitor.current++;
            var req = requestMonitor.current;
            window.SearchService.requests.push(function () {
                window.SearchService[storageKey].pendingRequests++;

                $.post(url, query)
                    .done(function (r) {
                        var rm = self.getRequestMonitor(url, query);
                        var rn = rm ? rm.current : 0;
                        if (req < rn) return;

                        window.SearchService.cache.push({
                            TimeStamp: new Date().getTime(),
                            response: JSON.parse(JSON.stringify(r)), // Clone the response so subsequent responses don't alter this one.
                            url: url,
                            query: query
                        });

                        callback(r);
                    })
                    .always(function () {
                        window.SearchService[storageKey].pendingRequests--;
                        if (window.SearchService[storageKey].pendingRequests === 0) {
                            notifyActivity('load complete');
                        }

                        window.log('Search service request made. ' + window.SearchService[storageKey].pendingRequests + ' requests pending.');
                    });
            });
        };

        // Allow another object to subscribe to notifications.
        // The observer will be notified whenever a request is made.
        self.observe = function (cb) {
            var key = 'K' + Math.floor(Math.random() * 999999);
            window.SearchService[storageKey].observers.push({ key: key, callback: cb });
            return key;
        };

        // Allow another object to subscribe to network activity notifications.
        self.observeActivity = function (cb) {
            window.SearchService[storageKey].notifyOnActivity.push(cb);
        };

        self.ShouldNotify = false;
        self.SearchKey = new Date().getTime();

        self.Notify = function (except, notifiedList) {
            if (self.ShouldNotify) {
                notify(except, notifiedList);
                self.ShouldNotify = false;
            }

            return self;
        };

        // Add a new search criteria, consisting of a type and a value.
        self.addTerm = function (s) {
            var existingTerm = _.find(window.SearchService[storageKey].search, function (st) {
                return st.type === s.type && st.value === s.value;
            });

            if (!existingTerm) {
                window.SearchService[storageKey].search.push({ type: s.type, value: s.value, description: s.description });
                self.ShouldNotify = true;
            }

            return self;
        };

        self.addTerms = function (terms) {
            _.each(terms, function (s) {
                var existingTerm = _.find(window.SearchService[storageKey].search, function (st) {
                    return st.type === s.type && st.value === s.value;
                });

                if (!existingTerm) window.SearchService[storageKey].search.push({ type: s.type, value: s.value, description: s.description });
            });

            return self;
        };

        self.allTerms = function () {
            return window.SearchService[storageKey].search;
        };

        self.hasTerm = function (t) {
            return _.some(window.SearchService[storageKey].search, function (st) {
                return st.type === t.type && st.value === t.value;
            });
        };

        self.getTerm = function (type) {
            return _.find(window.SearchService[storageKey].search, function (st) {
                return st.type.toLowerCase() === type.toLowerCase();
            });
        };

        // Returns true if the search includes a data parameter.
        self.dateSet = function () {
            return _.some(window.SearchService[storageKey].search, function (st) {
                return st.type === 'Date' || st.type === 'sd' || st.type === 'ed';
            });
        };

        // Remove a search criteria, based on a type and a value.
        self.removeTerm = function (s) {
            var c = window.SearchService[storageKey].search.length;
            var search = _.reject(window.SearchService[storageKey].search, function (st) {
                return st.type === s.type && st.value === s.value;
            });

            // Only notify if something has actually changed.
            if (c !== search.length) {
                window.SearchService[storageKey].search = search;
                self.ShouldNotify = true;
            }

            return self;
        };

        self.removeAllTerms = function () {
            window.SearchService[storageKey].search = [];
            self.ShouldNotify = true;
            return self;
        };

        self.updateTerm = function (s) {
            var existingTerm = _.find(window.SearchService[storageKey].search, function (st) {
                return st.type === s.type;
            });

            if (existingTerm) existingTerm.value = s.value;
            else window.SearchService[storageKey].search.push(s);

            self.ShouldNotify = true;

            return self;
        };

        self.removeTermByValue = function (t) {
            var s = _.reject(window.SearchService[storageKey].search, function (st) {
                return st.value === t;
            });

            if (s.length !== window.SearchService[storageKey].search.length) {
                window.SearchService[storageKey].search = s;
                self.ShouldNotify = true;
            }

            return self;
        };

        self.removeAllOfType = function (t) {
            var s = _.reject(window.SearchService[storageKey].search, function (st) {
                return st.type === t;
            });

            if (s.length !== window.SearchService[storageKey].search.length) {
                window.SearchService[storageKey].search = s;
                self.ShouldNotify = true;
            }

            return self;
        };

        self.updating = function () {
            return window.SearchService[storageKey].pendingRequests === 0;
        };

        var stylesRequest = function (cb) {
            self.request(serviceUrls.styles, { tags: JSON.stringify(window.SearchService[storageKey].search) }, cb);
        };

        var destinationsRequest = function (term, cb) {
            self.request(serviceUrls.destinations, { term: term, tags: JSON.stringify(window.SearchService[storageKey].search) }, cb, false);
        };

        var durationsRequest = function (cb) {
            self.request(serviceUrls.durations, { tags: JSON.stringify(window.SearchService[storageKey].search) }, cb);
        };

        var datesRequest = function (cb, month, year) {
            self.request(serviceUrls.dates, { tags: JSON.stringify(window.SearchService[storageKey].search), month: month, year: year }, cb);
        };

        var settingsRequest = function (cb) {
            self.request(serviceUrls.settings, { tags: JSON.stringify(window.SearchService[storageKey].search) }, cb);
        };

        var resultCountRequest = function (cb) {
            return self.request(serviceUrls.resultCount, { tags: JSON.stringify(window.SearchService[storageKey].search) }, cb);
        };

        var isCruiseSearch = function () {
            var href = window.location.href;
            var pathname = href.pathname;
            if (pathname == null) {
                var pathEndIndex = href.length;
                var queryIndex = href.indexOf("?");
                var fragmentIndex = href.indexOf("#");
                if (queryIndex > -1 && fragmentIndex > -1) {
                    pathEndIndex = Math.min(queryIndex, fragmentIndex);
                } else if (queryIndex > -1) {
                    pathEndIndex = queryIndex;
                } else if (fragmentIndex > -1) {
                    pathEndIndex = fragmentIndex;
                }

                pathname = href.substring(href.indexOf("/", "https://".length), pathEndIndex);
            }
            if (pathname != null && pathname === "/cruises/search") {
                return true;
            }
            return false;
        }

        self.isCruiseSearch = isCruiseSearch;

        var getResultsRequest = function (cb, sortBy, startAt, resultsToGet) {
            var url = isCruiseSearch()
                ? serviceUrls.cruiseSearchResultUrl
                : serviceUrls.searchResultServiceUrl;
            return self.request(
                url,
                {
                    tags: JSON.stringify(window.SearchService[storageKey].search),
                    sortBy: sortBy,
                    startAt: startAt,
                    retrieve: resultsToGet
                },
                cb
            );
        };

        var getFacetsRequest = function (cb) {
            var url = isCruiseSearch()
                ? serviceUrls.cruiseFiltersUrl
                : serviceUrls.searchResultFacetServiceUrl;
            return self.request(url, { tags: JSON.stringify(window.SearchService[storageKey].search) }, cb);
        };

        self.getHolidayStyles = function (cb) {
            return stylesRequest(cb);
        };

        self.getDestinations = function (term, cb) {
            return destinationsRequest(term, cb);
        };

        self.getDurations = function (cb) {
            return durationsRequest(cb);
        };

        self.getDates = function (cb, month, year) {
            return datesRequest(cb, month, year);
        };

        self.getSettings = function (cb) {
            return settingsRequest(cb);
        };

        self.getResultCount = function (cb) {
            return resultCountRequest(cb);
        };

        self.getResults = function (startBy, startAt, resultsToGet, cb) {
            return getResultsRequest(cb, startBy, startAt, resultsToGet);
        };

        self.getFacets = function (cb) {
            return getFacetsRequest(cb);
        };

        //retrive the cookie
        self.searchCookieValue = function (name) {
            var nameEQ = name + '=';
            var ca = document.cookie.split(';');

            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
            }

            return null;
        }

        // there are 2 routes to call this - on search (\app-Search\modules\statusArea\viewModel.js) and (\app-SearchResults\modules\urlWatcher\module.js)
        self.createCookie = function (name, value, minutes) {
            if (value != undefined) {
                var expires = "";

                if (minutes) {
                    var date = new Date();
                    date.setTime(date.getTime() + (minutes * 60 * 1000));
                    expires = "; expires=" + date.toGMTString();
                }

                document.cookie = name + "=" + value + expires + "; path=/";

                return true;
            }
        }

        function getDataTags() {
            if (saga.global.getSearchArrCookies() !== null) {
                var cookieValue = saga.global.getSearchArrCookies();
                var tags = _.filter(cookieValue, function (t) {
                    return t.type === 'g' || t.type === 'pc';
                });

                return tags;
            }

            return [];
        }

        function getSelectedDestinationFromCookie() {
            _.each(getDataTags(), function (t) {
                self.addTerm(t);
                self.Notify();
            });
        }

        getSelectedDestinationFromCookie();
    };
});

saga.global.getSearchArrCookies = function () {
    var searchedCookies = [];
    return searchedCookies;
}

saga.global.createCookie = function (name, value) {
    if (value != undefined) {
        document.cookie = name + "=" + value + "; path=/";
    }
};
